export default __webpack_public_path__ + "static/media/how-many-people-use-internet-at-home.579f8764.png";